import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import Header from '../components/Header';
import withNotify from '../common/withNotify';
import withLoader from '../common/withLoader';
import withTeam from '../common/withTeam';
import withUser from '../common/withUser';
import withOnline from '../common/withOnline';
import {
  onGoBack,
  sortData,
  storeUser,
  userLogout,
  Fcm_Token,
  storeVersionCode
} from '../common/globals';
import withGoBack from '../common/withGoBack';
import { reLogin } from '../utils/utils';
import Bugsnag from '../helpers/bugsnag';
import {
  APP_VERSION,
  REQUEST_SOURCE,
  APP_GENERATION
} from '../common/config';

class Teams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teams: []
    };
  }

  _onClickTeam = (team) => {
    try {
      const {
        user, setUser, setTeam, setLoader, notify, goBack, setGoBack, online
      } = this.props;
      setLoader(true);
      setTeam(team);
      const userData = Object.assign(user, { team: team.id, selectedTeam: team });
      setUser(userData);
      storeUser(userData);
      storeVersionCode();
      const reLoginData = {
        userId: user.loginPayload.userId,
        password: user.loginPayload.password,
        requestSource: REQUEST_SOURCE,
        lastAppVersion: APP_VERSION,
        appGeneration: APP_GENERATION,
        deviceId: user.loginPayload.deviceToken,
        deviceToken: user.loginPayload.deviceToken,
        fcmToken: Fcm_Token
      };

      if (online) {
        reLogin(reLoginData).then(async (response) => {
          setLoader(false);
          const { status } = response;
          if (status) {
            // Add office & team
            response.office = user.office;
            response.team = user.team;
            response.territoryId = user.territoryId;
            response.remember = user.remember;
            response.selectedTeam = user.selectedTeam;
            response.loginPayload = reLoginData;
            await storeUser(response);
            await storeVersionCode();
            setUser(response);
            goBack.push(window.location.pathname);
            setGoBack(goBack);
            browserHistory.push('/sync-data');
          } else {
            notify({ type: 'error', message: response.message });
            userLogout(false);
          }
        });
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  UNSAFE_componentWillMount() {
    try {
      const { user } = this.props;
      let { teams } = this.state;
      if (user.hasOwnProperty('territories')) {
        user.territories.map((territoriesData) => {
          if (territoriesData.hasOwnProperty('offices')) {
            const officeIndex = _.findIndex(territoriesData.offices, { id: user.office });
            if (officeIndex !== -1) {
              teams = sortData(territoriesData.offices[officeIndex].teams, 'name');
              //  teams = territoriesData.offices[officeIndex].teams;
            }
          }
        });
      }
      this.setState({ teams });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { teams } = this.state;
    const { goBack } = this.props;
    return (
      <section className="list-section">
        <Header
          title="Teams"
          goBack={() => onGoBack(goBack)}
        />
        <div className="container">
          <ul className="select-list list-unstyled">
            {
              teams !== undefined && teams.length > 0
                ? teams.map((team, index) => (
                  <Link style={{ cursor: 'pointer' }} key={index} onClick={() => this._onClickTeam(team)}>
                    <li>{team.name}</li>
                  </Link>
                ))
                : <h6 className="text-center mt-5">No teams available</h6>
            }
          </ul>
        </div>
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'TeamsForm',
});

export default withTeam(
  withGoBack(
    withUser(
      withForm(
        withNotify(
          withLoader(
            withOnline(
              Teams
            )
          )
        )
      )
    )
  )
);
